import * as EntityClasses from "@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g";
import * as Entities from "@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g";

/**
 * AtpItem entity interface.
 */
export interface IAtpItem {
  ProductReferenceNumber?: string;
  Quantity?: number;
  SiteId?: string;
  ExtensionProperties?: Entities.CommerceProperty[];
}

/**
 * AtpItemResponse entity interface.
 */
export interface IAtpItemResponse {
  AtpDate?: string;
  ItemId?: string;
  Qty?: string;
  SiteId?: string;
}

/**
 * GetATPDatesResponse entity interface.
 */
export interface IGetATPDatesResponse {
  ResponseStatusCode?: number;
  Message?: string;
  AtpList?: IAtpItemResponse[];
}

/**
 * AtpItemResponse entity class.
 */
export class AtpItemResponseExtensionClass implements IAtpItemResponse {
  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public AtpDate: string;

  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public ItemId: string;

  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public Qty: string;

  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public SiteId: string;

  // Navigation properties names

  /**
   * Construct an object from odata response.
   * @param {any} odataObject The odata result object.
   */
  constructor(odataObject?: any) {
    odataObject = odataObject || {};
    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    this.AtpDate = odataObject.AtpDate;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    this.ItemId = odataObject.ItemId;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    this.Qty = odataObject.Qty;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    this.SiteId = odataObject.SiteId;
  }
}

/**
 * GetATPDatesResponse entity class.
 */
export class GetATPDatesResponseExtensionClass implements IGetATPDatesResponse {
  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public ResponseStatusCode: number;

  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public Message: string;

  // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
  public AtpList: IAtpItemResponse[];

  // Navigation properties names

  /**
   * Construct an object from odata response.
   * @param {any} odataObject The odata result object.
   */
  constructor(odataObject?: any) {
    odataObject = odataObject || {};
    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    this.ResponseStatusCode = odataObject.ResponseStatusCode;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    this.Message = odataObject.Message;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    this.AtpList = undefined;
    if (odataObject.AtpList) {
      this.AtpList = [];
      for (var i = 0; i < odataObject.AtpList.length; i++) {
        if (odataObject.AtpList[i]) {
          if (odataObject.AtpList[i]["@odata.type"]) {
            var className: string = odataObject.AtpList[i]["@odata.type"];
            className = className
              .substr(className.lastIndexOf(".") + 1)
              .concat("Class");
            // @ts-ignore
            if (EntityClasses[className]) {
              // @ts-ignore
              this.AtpList[i] = new EntityClasses[className](
                odataObject.AtpList[i],
              );
            }
          } else {
            this.AtpList[i] = new AtpItemResponseExtensionClass(
              odataObject.AtpList[i],
            );
          }
        } else {
          // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
          this.AtpList[i] = undefined;
        }
      }
    }
  }
}
